import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-picture',
  templateUrl: './user-picture.component.html',
  styleUrls: ['./user-picture.component.scss']
})
export class UserPictureComponent implements OnInit, OnDestroy {

  user: User;
  userSubscription: Subscription;

  fileIsUploading = false; // picture update status

  constructor(private authService: AuthService,
              private configService: ConfigService,
              private userService: UserService,) { }

  ngOnInit(): void {
    this.subscribeToUser();
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {this.userSubscription.unsubscribe(); }
  }

  subscribeToUser() {
    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );
    this.authService.emitUser();
  }

  onThemeChange() {
    this.configService.onSwitchTheme();
  }

  async detectFiles(event) {
    let file: File = event.target.files[0];

    // start picture update
    this.fileIsUploading = true;
    await this.userService.updatePicture(file);

    // picture update complete
    this.fileIsUploading = false;
  }
}
